import styled from 'styled-components';
import { Checkbox } from 'shared/components/Checkbox';
import { FormikInput } from 'shared/components/FormikInput';
import { variableFontRegular } from 'styles/theme/text';
import { NewsletterSignUpCheckbox } from 'account/components/NewsLetterSignUpCheckbox';
import { t } from 'localization/utils/t';

const TP = 'checkout.components.Account.GuestEmailForm';

export const GuestEmailForm = ({ isNewsletterSignUpChecked, handleNewsletterSignUpChange }) => {
  return (
    <GuestEmailForm.Wrapper>
      <GuestEmailForm.FormikInput
        autoComplete="email"
        data-qa="create_account_email_input"
        label={t(`${TP}.createAccountEmailInput`, 'Email')}
        name="email"
        type="email"
      />
      <NewsletterSignUpCheckbox
        isNewsletterSignUpChecked={isNewsletterSignUpChecked}
        handleNewsletterSignUpChange={handleNewsletterSignUpChange}
      />
    </GuestEmailForm.Wrapper>
  );
};

GuestEmailForm.Wrapper = styled.div`
  margin-bottom: 24px;
`;

GuestEmailForm.FormikInput = styled(FormikInput)`
  margin-bottom: unset;
  margin-bottom: 24px;
`;

GuestEmailForm.Checkbox = styled(Checkbox)`
  ${variableFontRegular({ size: '11px', height: '14px' })};
`;
